import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useLazyApplyVoucherQuery} from "@CheckOrder/api/checkOrderApi";

export default function useAddVoucher(voucherCode: string) {
    const [applyVoucher] = useLazyApplyVoucherQuery()
    const {ticket} = useAppSelector((state) => state?.checkOrder)

    return () => applyVoucher({
        ticket,
        ticket_code: ticket.ticketCode,
        voucher_code: voucherCode,
    })
}